// src/components/detectionOfDataLeaks.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaShieldAlt, FaSearch, FaTasks, FaLightbulb } from 'react-icons/fa';
import Footer from './footer';
import './detectionOfDataLeaks.css';
import DetectionIcon from '../assets/detection-icon.svg';
import SubpagesVector from '../assets/subpages-vector.svg';

function DetectionOfDataLeaks() {
  const { t } = useTranslation();

  return (
    <div className="cybersecurity-posture-view">
      <div className="gradient-background" />

      <div className="cybersecurity-posture-content">
        {/* HERO WRAPPER */}
        <div className="posture-hero-wrapper">
          <div className="posture-hero-background" />
          <div className="posture-hero-container">
            <div className="posture-hero-content">
              <h1 className="posture-title">
                {t('dataLeak')}
                <img
                  src={DetectionIcon}
                  alt="Data Leak Icon"
                  className="shield-icon"
                />
              </h1>
              <h1 className="assessment-title">{t('detectionData')}</h1>
              <p className="subtitle">{t('dataLeakHeroSubtitle')}</p>
            </div>
          </div>
        </div>

        {/* EXPOSURE PHASE SECTION */}
        <div className="critical-phase-section">
          <h2 className="critical-phase-subtitle">
            {t('exposurePhaseSubtitle')}
          </h2>
          <div className="critical-phase-grid">
            {/* Item 1 */}
            <div className="critical-phase-item">
              <div className="critical-phase-title">
                <FaShieldAlt className="critical-phase-icon" />
                <span>{t('comprehensiveLeakScanning')}</span>
              </div>
              <div className="critical-phase-item-line" />
              <p>{t('comprehensiveLeakScanningDesc')}</p>
            </div>
            {/* Item 2 */}
            <div className="critical-phase-item">
              <div className="critical-phase-title">
                <FaSearch className="critical-phase-icon" />
                <span>{t('evidenceBasedReporting')}</span>
              </div>
              <div className="critical-phase-item-line" />
              <p>{t('evidenceBasedReportingDesc')}</p>
            </div>
            {/* Item 3 */}
            <div className="critical-phase-item">
              <div className="critical-phase-title">
                <FaTasks className="critical-phase-icon" />
                <span>{t('cvssRiskRanking')}</span>
              </div>
              <div className="critical-phase-item-line" />
              <p>{t('cvssRiskRankingDesc')}</p>
            </div>
            {/* Item 4 */}
            <div className="critical-phase-item">
              <div className="critical-phase-title">
                <FaLightbulb className="critical-phase-icon" />
                <span>{t('actionableRemediation')}</span>
              </div>
              <div className="critical-phase-item-line" />
              <p>{t('actionableRemediationDesc')}</p>
            </div>
          </div>
        </div>

        {/* POST-EXPOSURE PHASE SECTION */}
        <div className="post-critical-phase-section">
          <img
            src={SubpagesVector}
            alt="Subpages Vector"
            className="post-critical-phase-image"
          />
          <p className="post-critical-phase-text">
            {t('postExposurePhaseText')}
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default DetectionOfDataLeaks;
